export {default} from './ConnectedIndicator';
